import { gql } from "graphql-request";
import * as z from "zod";

export const MigrationData = z.object({
  migrationName: z.string(),
  updateHash: z.string().nullish(),
});

export type MigrationData = z.infer<typeof MigrationData>;

export const MigrationDataFragment = gql`
  fragment MigrationDataFragment on MigrationData {
    migrationName
    updateHash
  }
`;
